export const LegendIcon = ({ fill = "#D3D7DA" }) => {
  return (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="6.5" cy="6" r="5.5" fill={fill} stroke="#A8AFB5" />
    </svg>
  );
};
